import React, { useState, useEffect } from 'react';
import { getUserCountryInfo } from '../../utils/geolocation';

const LocationIndicator = () => {
  const [locationInfo, setLocationInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const detectLocation = async () => {
      try {
        const info = await getUserCountryInfo();
        setLocationInfo(info);
      } catch (error) {
        console.error('Failed to detect location:', error);
        setLocationInfo({ country: 'Unknown', isTunisia: false });
      } finally {
        setLoading(false);
      }
    };

    detectLocation();
  }, []);

  if (loading) {
    return (
      <div className="flex items-center text-sm text-gray-600">
        <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-yellow-600 mr-2"></div>
        Détection de localisation...
      </div>
    );
  }

  if (!locationInfo) {
    return null;
  }

  return (
    <div className="flex items-center text-sm">
      {locationInfo.isTunisia ? (
        <div className="flex items-center text-green-700">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
          <span>Localisé en Tunisie - Paiement à la livraison disponible</span>
        </div>
      ) : (
        <div className="flex items-center text-gray-600">
          <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <span>Localisé en {locationInfo.country}</span>
        </div>
      )}
    </div>
  );
};

export default LocationIndicator; 